// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"Editor_editorContainer__1hG2v","textInput":"Editor_textInput__2c8ZW"};